export const buildDragTrackData = (
	track: Track,
	source: string
): DragTrackData => ({
	id: track.id,
	title: track.title,
	albumNumber: track.album.number,
	trackSource: source,
	catalogue: track.album.catalogue?.name ?? '',
	genre: track.album.genre ?? '',
})

type DragPosition = 'above' | 'below'

export const getDragPosition = (
	boundingRect: { top: number; bottom: number },
	clientY: number
): DragPosition =>
	clientY - boundingRect.top < boundingRect.bottom - clientY ? 'above' : 'below'

export const shouldSkipDrop = (
	oldPosition: number,
	newPosition: number,
	goesAbove: boolean,
	goesBelow: boolean
): boolean => {
	if (oldPosition === -1) {
		return false
	}
	if (oldPosition === newPosition) {
		return true
	}
	if (oldPosition - 1 === newPosition && goesBelow) {
		return true
	}
	if (oldPosition + 1 === newPosition && goesAbove) {
		return true
	}
	return false
}

export const sortTrackOrder = (
	oldPosition: number,
	newPosition: number,
	tracksInExistingOrder: Track[]
): Track[] => {
	const list = [...tracksInExistingOrder]
	const [removed] = list.splice(oldPosition, 1)
	list.splice(newPosition, 0, removed)

	return list
}

export const clearDragRowIndicators = (): void => {
	document.querySelectorAll('[class*="trackRowDrag"]').forEach((node) => {
		const el = node as HTMLElement
		el.classList.remove('trackRowDragAbove', 'trackRowDragBelow')
		delete el.dataset.dragPosition
	})
}
